export default __webpack_public_path__ + "static/media/hashoo-logo.a087a60f.svg";